var ctReportModel;
(function ($) {
 	$.fn.capitechReport = function(options) {
		
		var $this = $(this);
		var $capitechReportElm = $this[0];
		ctReportModel = ko.viewmodel.fromModel({content:[], selectedReportId:[], selectedReport:{}});
		ko.applyBindings(ctReportModel,$capitechReportElm);
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			setInitialDates();
			getAvaliableReports();
		}
		
		function getAvaliableReports() {
			var success = function (data, textStatus, jqXHR) {
				loaderIndicator(false);
				if (data.success == true && data.content.length > 0) {
					ko.viewmodel.updateFromModel(ctReportModel, data);
					ctReportModel.selectedReportId(ctReportModel.content()[0].id());
					ctReportModel.selectedReport = ctReportModel.content()[0];
					if (ctReportModel.content()[0].requiresFromAndToDates()) {
						showHideDateFields('block');
					}
				} else {
					sweetAlert("No reports", "You have no available reports.", "error");
				}
			}
			var error = function (jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Validation error", "API error: API not accessible", "error");
			}
			loaderIndicator(true);
			_api.getAvaliableReports_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), _appSettingsObj.language);
		}
		
		function getSelectedReport(reportId, reportDateFrom, reportDateTo) {
			var success = function (data, textStatus, jqXHR) {
				var markup = getResource('report.noContent', 'This report contains no data');
				loaderIndicator(false);
				if (data.success == true && data.content.length > 0) {
					
					$('#ct-rendered-report-title').text(data.content[0].name);
					if (data.content[0].hasResults) {
						markup = data.content[0].resultHtml;
					}
					$('#ct-rendered-report-content').html(markup);
					$('#ct-rendered-report').show(500);
					
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			}
			var error = function (jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				displayAjaxErrorAlert(jqXHR, false);
			}
			loaderIndicator(true);
			_api.getReport_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), _appSettingsObj.language, reportId, reportDateFrom, reportDateTo);
		}
		
		function showHideDateFields(displayType) {
			var bRequired = true,
				$reportDateFrom = $('input#reportDateFrom'),
				$reportDateTo = $('input#reportDateTo');
				
			if (displayType == 'none') {
				bRequired = false;
			}
			
			$reportDateFrom.prop('required', bRequired)
						   .parent().css('display', displayType);
			$reportDateTo.prop('required', bRequired)
						 .parent().css('display', displayType);
		}
		
		function setInitialDates() {
			var $reportDateFromElm = $this.find('input#reportDateFrom');
			var $reportDateToElm = $this.find('input#reportDateTo');
			var currentDate = new Date();
			
			$reportDateFromElm.val(moment(moment(currentDate).startOf('month')).format('YYYY-MM-DD'));
			$reportDateToElm.val(moment(currentDate).format('YYYY-MM-DD'));
			
			// Add mask if input type date not supported
			if (Modernizr.inputtypes.date === false) {
				$reportDateFromElm.inputmask({'formatAlias':'isoDate'});
				$reportDateToElm.inputmask({'formatAlias':'isoDate'});
			}
		}
		
		// event handlers
		/*////////////////////////////////////////////////////////////*/
		$($capitechReportElm).on('submit', 'form', function(evt) {
			evt.preventDefault();
			
			var $this = $(this),
				reportId,
				reportDateFrom,
				reportDateTo;
			
			if (ctReportModel.selectedReport.id()) {
					reportId = ctReportModel.selectedReport.id();
					reportDateFrom = $this.find('input#reportDateFrom').val();
					reportDateTo = $this.find('input#reportDateTo').val();
				if (ctReportModel.selectedReport && ctReportModel.selectedReport.requiresFromAndToDates() !== true) {
					reportDateFrom = null;
					reportDateTo = null;
				}
				getSelectedReport(reportId, reportDateFrom, reportDateTo);
			} else {
				sweetAlert(getResource('app.informationTitle'), getResource('report.pleaseSelectReport'), "error");
			}
		});
		
		$($capitechReportElm).on('focus blur change', 'select', function(evt) {
			var selectedReportId = parseInt($(this).val());
			var tempSelectedReport = ko.utils.arrayFirst(ctReportModel.content(), function(category) {
				return parseInt(category.id()) === selectedReportId;
			});
			ctReportModel.selectedReport = tempSelectedReport;
			
			if (ctReportModel.selectedReport && ctReportModel.selectedReport.requiresFromAndToDates()) {
				showHideDateFields('block');
			} else {
				showHideDateFields('none');
			}
		});
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));